import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';
import SrModalV2, {
  MODAL_THEME_STACK,
} from 'client/components/SrModalV2/SrModalV2';
import SrFormikField, {
  SR_FIELD_THEME_ADOBE,
} from 'client/components/SrFormikField';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

import './SrTourFeedback.less';

const getTextBasedOnRating = (rating) => {
  switch (rating) {
    case 5:
      return 'Amazing! What did you like?';
    case 4:
      return 'Pretty good! What could improve?';
    case 3:
      return 'Only average. What could improve?';
    case 2:
      return 'Not so good. What could improve?';
    default:
      return 'Very Poor. What could improve?';
  }
};

const SrTourFeedbackStepStars = ({
  listing,
  isSmallScreen,
  isSubmitting,
  isMobileApp,
  formikBag,
  formFields,
  onClose,
}) => {
  return (
    <SrModalV2
      showCloseButton={false}
      closeOnBackgroundClick
      onClose={() => onClose(formikBag.values)}
      padding='0'
      contentMaxWidth={!isSmallScreen ? '375px' : null}
      theme={MODAL_THEME_STACK}
    >
      <div styleName={classnames('feedbackStep', { isMobileApp: isMobileApp })}>
        <SrBox
          styleName='propertyImage'
          backgroundImage={`url("${listing.sunroomPhotoUrls[0]}")`}
        />
        <SrBox height='16px' />
        <SrText font='greycliff' weight='800' size='21' lineHeight='30px' align='center'>
          How was the tour at <br />
          {listing.addressStreetDisplay}?
        </SrText>
        <SrFormikField
          formField={formFields.find((formField) => formField.id === 'rating')}
          formikBag={formikBag}
        />
        <SrBox height='16px' />
        <SrText font='greycliff' weight='700'>
          {getTextBasedOnRating(formikBag.values.rating)}
        </SrText>
        <SrFormikField
          formField={formFields.find((formField) => formField.id === 'tags')}
          formikBag={formikBag}
        />
        <SrBox margin='10px 0 30px' minWidth='100%'>
          <SrFormikField
            formField={formFields.find((formField) => formField.id === 'feedback')}
            formikBag={formikBag}
            theme={SR_FIELD_THEME_ADOBE}
          />
        </SrBox>
        <SrButton
          hasBoxShadow
          theme={SR_BUTTON_THEME_ADOBE_GREEN}
          onClick={formikBag.handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submit ...' : 'Submit'}
        </SrButton>
      </div>
    </SrModalV2>
  );
};

SrTourFeedbackStepStars.propTypes = {
  listing: PropTypes.object.isRequired,
  formikBag: PropTypes.object.isRequired,
  formFields: PropTypes.array.isRequired,
  isSmallScreen: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

SrTourFeedbackStepStars.displayName = 'SrTourFeedbackStepStars';

export default SrTourFeedbackStepStars;
